import { render } from "./BuildingLocationPointsView.vue?vue&type=template&id=129a5a01&scoped=true"
import script from "./BuildingLocationPointsView.vue?vue&type=script&lang=js"
export * from "./BuildingLocationPointsView.vue?vue&type=script&lang=js"

import "./BuildingLocationPointsView.vue?vue&type=style&index=0&id=129a5a01&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129a5a01"]])

export default __exports__